import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, BaasicButton, BaasicFormControls, BasicInput, BasicCheckbox, BasicFieldCheckbox, BaasicModal } from 'core/components';
import { ApplicationEditLayout, Content, PageFooter } from 'core/layouts';
import { isEmptyString, toDate, uuid } from 'core/utils';
import { ImportItemGroupEdit } from 'application/import/pages';
import _ from 'lodash';
import { PatientScrollArrow } from "application/facility-order/components";

function ImportPatientEditTemplate({ editView, t }) {
    const {
        item,
        contentLoading,
        form,
        itemsConstructed,
        isFormDisabled,
        goToPreview,
        rootStore,
        importItems,
        itemGroupEditModal,
        openItemGroupEdit,
        isProcessing,
        facility,
        brightreeBaseUrl,
        primaryInsurance,
        toggleReviewed,
        reviewed,
        isAvalibleForImport,
        trackingCaseList,
        createCase,
        isCreateCase,
        patient,
        nextPatientGroupId,
        previousPatientGroupId,
        goToNextPatient,
        goToPreviousPatient
    } = editView;

    let templateUpdates = [];
    {
        item && itemsConstructed && _.each(item.items, (groupItems) => {
            let salesOrderNotes = _.uniq(_.filter(_.map(groupItems, 'salesOrderNote'), i => { return !isEmptyString(i); }));
            let templateId = _.first(groupItems).templateId;
            let firstItem = _.first(groupItems);
            var salesOrderId = firstItem.salesOrderId;
            let category = firstItem.itemCategory_;
            let categoryExist = category || firstItem.itemCategory;
            let diagnosisCodes = [];
            _.each(groupItems, c => {
                diagnosisCodes.push(c.diagnosisCode1);
                diagnosisCodes.push(c.diagnosisCode2);
                diagnosisCodes.push(c.diagnosisCode3);
                diagnosisCodes.push(c.diagnosisCode4);
                diagnosisCodes.push(c.diagnosisCode5);
                diagnosisCodes.push(c.diagnosisCode6);
                diagnosisCodes.push(c.diagnosisCode7);
                diagnosisCodes.push(c.diagnosisCode8);
            });
            diagnosisCodes = _.uniq(_.filter(diagnosisCodes, i => { return !isEmptyString(i); }));
            const categoryItems = groupItems.map(i =>
                <tr key={i.id}>
                    <td className="table__cell--has-input"><BaasicFieldDropdown field={form.$('items').$('item-' + i.id).$('product')} store={i.productStore} labelDisplayed={false} /></td>
                    <td className="table__cell--has-input"><BasicInput field={form.$('items').$('item-' + i.id).$('quantity')} /></td>
                    <td className="table__cell--has-input"><BasicInput field={form.$('items').$('item-' + i.id).$('salesOrderQuantity')} /></td>
                    <td><React.Fragment>{i.itemName}</React.Fragment></td>
                    <td><React.Fragment>{i.reference}</React.Fragment></td>
                    <td><React.Fragment>{i.insuranceInfo}</React.Fragment></td>
                    <td><React.Fragment>{i.inactiveReason}</React.Fragment></td>
                    <td><React.Fragment>{i.note}</React.Fragment></td>
                    <td><React.Fragment>{i.importDetailStatus.name}</React.Fragment></td>
                    <td><React.Fragment>{i.errorMessage}</React.Fragment></td>
                    <td><React.Fragment>{i.action}</React.Fragment></td>
                    <td><React.Fragment>{i.templateItemId}</React.Fragment></td>
                </tr>
            );

            let templateUpdateItem =
                <div key={uuid()}>
                    {isCreateCase && <BaasicButton label="Create Case" className="btn btn--base btn--primary u-mar--bottom--sml" onClick={() => createCase(groupItems)} />}

                    <table className="table--preview table--preview--big u-mar--bottom--med" >
                        <thead>
                            <tr>
                                <th>{t('IMPORT_PATIENT.EDIT.PRODUCT')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.TEMPLATE_QUANTITY')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.SALES_ORDER_QUANTITY')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.ITEM_NAME')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.REFERENCE')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.INSURANCE_INFO')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.INACTIVE_REASON')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.NOTE')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.STATUS')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.ERROR_MESSAGE')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.ACTION')}</th>
                                <th>{t('IMPORT_PATIENT.EDIT.TEMPLATE_ITEM_ID')}</th>
                            </tr>
                        </thead>
                        <tbody>

                            {categoryItems}
                            <tr className="table--preview--special">
                                <td colSpan="1">
                                    {categoryExist &&
                                        <span className="table--preview__note table--preview--check">

                                            <div className="u-display--ib table__checkbox">
                                                <BasicFieldCheckbox
                                                    field={form.$('templates').$('template-' + firstItem.itemGroupId).$('billableToMedicare')} />
                                            </div>
                                            <span className="table--preview--checklabel">
                                                <strong>{t('Billable to Medicare')}</strong>
                                            </span>

                                            <div className="validation__message">
                                                {(form.$('templates').$('template-' + firstItem.itemGroupId).$('billableToMedicare')).error}
                                            </div>
                                        </span>}
                                </td>
                                <td colSpan="1">
                                    <span className="table--preview__note">
                                        <strong>{t('IMPORT_PATIENT.EDIT.TEMPLATE_ID')}: </strong>
                                        <React.Fragment>{templateId ?
                                            <a target='_blank' href={brightreeBaseUrl + 'OrderEntry/frmSOOrderRO.aspx?SalesOrderTemplateKey=' + templateId + '&ShowAck=0&Edit=0'}>{templateId}</a>
                                            : 'N/A'}</React.Fragment>
                                    </span>
                                </td>
                                <td colSpan="1">
                                    <span className="table--preview__note">
                                        <strong>{t('IMPORT_PATIENT.EDIT.SALES_ORDER_ID')}: </strong>
                                        <React.Fragment>{salesOrderId ?
                                            <a target='_blank' href={brightreeBaseUrl + 'OrderEntry/frmSOOrderRO.aspx?SalesOrderKey=' + salesOrderId + '&ShowAck=0&Edit=0'}>{salesOrderId}</a>
                                            : 'N/A'}</React.Fragment>
                                    </span>
                                </td>
                                <td colSpan="1">
                                    <span className="table--preview__note">
                                        <strong>{t('IMPORT_PATIENT.EDIT.ITEM_CATEGORY')}: </strong>
                                        <React.Fragment>{categoryExist ? (firstItem.itemCategory ? firstItem.itemCategory : (category ? category.name : 'N/A')) : 'N/A'} </React.Fragment>
                                    </span>
                                </td>
                                <td colSpan="3">
                                    <span className="table--preview__note">
                                        <strong>{t('IMPORT_PATIENT.EDIT.DIAGNOSIS_CODES')}: </strong>
                                        <React.Fragment>{diagnosisCodes.length ? _.join(diagnosisCodes, ', ') : 'N/A'}</React.Fragment>
                                    </span>
                                </td>
                                <td colSpan="3">
                                    <span className="table--preview__note">
                                        <strong>{t('IMPORT_PATIENT.EDIT.SALES_ORDER_NOTE')}: </strong>
                                        <React.Fragment>{salesOrderNotes.length ? _.join(salesOrderNotes, ', ') : 'N/A'}</React.Fragment>
                                    </span>
                                </td>
                                <td colSpan="1">
                                    <span className="table--preview__note">
                                        <div className="table__icons">
                                            <BaasicButton label="Edit" onlyIcon={true} icon="u-icon u-icon--sml u-icon--edit" className="btn btn--icon" onClick={() => openItemGroupEdit(firstItem.itemGroupId, firstItem.patientId)} />
                                        </div>
                                    </span>
                                </td>
                                <td colSpan="1">
                                    <div className="table--preview__note">
                                        <strong>Wound location: </strong>{firstItem.woundLocation}
                                    </div>
                                    <div className="table--preview__note">
                                        <strong>Secondary verified: </strong>{firstItem.secondaryVerified}
                                    </div>
                                </td>
                            </tr>
                            <tr className="table--preview__gap">
                                <td>&nbsp;</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            templateUpdates.push(templateUpdateItem);
        })
    }

    return (
        <div>
            <ApplicationEditLayout store={editView} disabled={isFormDisabled}>

                <Content loading={contentLoading} >
                    <div className="row">
                        <div className="col col-sml-12 col-lrg-12">
                            <div className="card card--form card--primary card--med u-mar--bottom--med">
                                <div className="card__header u-mar--bottom--sml form__title form__title--preview">
                                    <h4 className="">
                                        {item && <React.Fragment>{item.firstName} {item.lastName} </React.Fragment>}
                                    </h4>
                                    {item && item.patientBtId ?
                                        (
                                            <BaasicButton className='btn btn--base btn--ghost u-mar--left--auto' label={'Patient preview'} onClick={() => goToPreview(item.patientBtId, item.firstName, item.lastName)} />
                                        )
                                        : null
                                    }
                                    <div className={item && item.patientBtId ? "u-flex--justify-end u-mar--left--tny" : "u-flex--justify-end u-mar--left--auto"} >
                                        <PatientScrollArrow direction="left" disabled={previousPatientGroupId ? false : true} scrollPatient={goToPreviousPatient} />
                                        <PatientScrollArrow direction="right" disabled={nextPatientGroupId ? false : true} scrollPatient={goToNextPatient} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-lrg-3">
                                        <div className="form__group__label is-preview">{t('IMPORT_PATIENT.EDIT.FACILITY')}</div>
                                        <span>
                                            {item && facility && <React.Fragment>{facility.name}</React.Fragment>}
                                        </span>
                                    </div>
                                    <div className="col col-lrg-3">
                                        <div className="form__group__label is-preview">{t('IMPORT_PATIENT.EDIT.PRIMARY_INSURANCE')}</div>
                                        <span>
                                            {item && <React.Fragment>{primaryInsurance ? primaryInsurance.name : 'No Insurance Listed'}</React.Fragment>}
                                        </span>
                                    </div>
                                    <div className="col col-lrg-2">
                                        <div className="form__group__label is-preview">Reviewed</div>
                                        {item && <BasicCheckbox id="reviewed" checked={reviewed} onChange={() => toggleReviewed()} />}
                                    </div>
                                    <div className="form__group col col-lrg-4">
                                        <div className="row">
                                            <div className="form__group__label col is-preview">Tracking Cases</div>
                                        </div>
                                        <div className="row">
                                            {trackingCaseList && trackingCaseList.length > 0 && <div className="col col-med-8">
                                                {trackingCaseList.map(trackingCase => {
                                                    const trackingCaseItem = [trackingCase.docCode, trackingCase.itemCategory.name, toDate(trackingCase.validTo)];
                                                    return (
                                                        <div className="row" key={trackingCase.id}>
                                                            <div className="col col-lrg-12">
                                                                <a onClick={() => rootStore.routerStore.goTo(
                                                                    'master.app.main.tracking-case.preview', { id: trackingCase.id })}>
                                                                    {trackingCaseItem.join(" - ")}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>}
                                            {patient && patient.data.item[0] && <div className="col col-med-2">
                                                <a onClick={() => {
                                                    window.open(
                                                        `${rootStore.routerStore
                                                            .findRoute('master.app.main.tracking-case.list').pattern}?patientId=${patient.data.item[0].id}`
                                                    )
                                                }
                                                }>
                                                    Show All
                                                </a>
                                            </div>}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <h4 className="form__title form__title--preview">Items</h4>
                            <div className="card card--form card--primary card--med">
                                <div className="table--preview__wrap">
                                    {/* <table className="table--preview table--preview--big"> */}
                                    {templateUpdates}
                                    {/* </table> */}
                                </div>
                            </div>
                        </div>
                    </div>

                </Content>
                <PageFooter>
                    <BaasicFormControls
                        form={form}
                        onSubmit={form.onSubmit}
                        disabled={isFormDisabled || isProcessing}
                        authorized={rootStore.permissionStore.hasPermission('portalSection.create')}
                    />
                    <BaasicButton
                        className='btn btn--base btn--primary'
                        label={t('Import')}
                        onClick={() => importItems()}
                        disabled={isFormDisabled || isProcessing || !isAvalibleForImport}
                        icon={isProcessing ? 'u-icon u-icon--med u-icon--sync u-rotate--login' : 'u-display--none'}
                        authorized={rootStore.permissionStore.hasPermission('portalSection.create')}
                    />
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={t('Back')}
                        onClick={() => rootStore.routerStore.goBack()}
                        icon='u-icon u-icon--xsml u-icon--btn-back'
                    />
                </PageFooter>

            </ApplicationEditLayout>
            <BaasicModal modalParams={itemGroupEditModal} className="modal__content modal--med">
                <ImportItemGroupEdit />
            </BaasicModal>

        </div>
    )
}

ImportPatientEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ImportPatientEditTemplate);
